import { render, staticRenderFns } from "./appContent.vue?vue&type=template&id=2c917022"
import script from "./appContent.vue?vue&type=script&lang=js"
export * from "./appContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports